module.exports = __webpack_public_path__ + "static/img/evCargo.13761352.png";